import api from '../axiosConfig';

const API_URL = '/api/stone'; 

export const fetchStones = () => api.get(API_URL);
export const createStone = (data) => api.post(API_URL, data);
export const updateStone = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteStone = (id) => api.delete(`${API_URL}/${id}`);
